import { render } from "./Ballot.vue?vue&type=template&id=97f4e024"
import script from "./Ballot.vue?vue&type=script&lang=js"
export * from "./Ballot.vue?vue&type=script&lang=js"

import "./Ballot.vue?vue&type=style&index=0&id=97f4e024&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__